module.exports = __webpack_public_path__ + "img/71_24.7bf9b45e.png";